export default "__VITE_ASSET__DpcjhL_W__"